import config from './config'
import theme from './theme'

export default {
    config,
    theme
}


// WEBPACK FOOTER //
// ./src/app/configuration/FordAP/index.js